import { PaletteOptions } from "@mui/material";
interface CustomPaletteOptions extends PaletteOptions {
    textColor: {
        main: string;
        secondary: string;
        xmain: string;
    };
    basicColor: {
        white: "#fff";
        black: "#000";
    };
}

export const lightPalette: CustomPaletteOptions = {
    primary: {
        main: "#0b6fb8",
    },
    secondary: {
        main: "#5f7a9d",
    },
    textColor: {
        main: "#000",
        secondary: "#999",
        xmain: "#fff",
    },
    basicColor: {
        white: "#fff",
        black: "#000",
    },
};
